import type { Market, PriceRow } from "@/lib/api";
import type { MarketImageMeta } from "@/lib/market-images";

export interface ExplorerMarket extends Pick<Market, "id" | "slug" | "name" | "cityName" | "regionSlug" | "latestRecordedDate" | "address" | "phone" | "district" | "website" | "lat" | "lng" | "geoConfidence"> {
  image?: MarketImageMeta;
}

export function groupMarketsByCity(markets: ExplorerMarket[]) {
  const grouped = new Map<string, ExplorerMarket[]>();
  for (const market of markets) {
    const list = grouped.get(market.cityName) ?? [];
    list.push(market);
    grouped.set(market.cityName, list);
  }
  for (const list of grouped.values()) {
    list.sort((a, b) => {
      const aCenter = /merkez/i.test(a.name) ? 0 : 1;
      const bCenter = /merkez/i.test(b.name) ? 0 : 1;
      return aCenter - bCenter || a.name.localeCompare(b.name, "tr");
    });
  }
  return grouped;
}

export function shortMarketName(market: ExplorerMarket) {
  return market.name
    .replace(new RegExp(`^${market.cityName}\\s*`, "i"), "")
    .replace(/Toptancı\s+Hali/i, "")
    .replace(/Belediyesi\s*/i, "")
    .replace(/[()]/g, "")
    .trim() || "Merkez Hal";
}

export function latestDate(rows: PriceRow[], fallback?: string | null) {
  return rows.reduce((latest, row) => {
    const date = row.recordedDate.slice(0, 10);
    return date > latest ? date : latest;
  }, fallback?.slice(0, 10) ?? "");
}

export function sortProductRows(rows: PriceRow[]) {
  return [...rows].sort((a, b) => a.productName.localeCompare(b.productName, "tr"));
}

export function usableProductRows(rows: PriceRow[]) {
  return rows.filter((row) => [row.minPrice, row.maxPrice, row.avgPrice].some((value) => Number(value) > 0));
}
